const OrderType = Object.freeze({
  BONUS: 'bonus',
  CORPORATE: 'corporate',
  CONSUMER: 'consumer',
});

export default OrderType;
